// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { DateTime } from 'luxon'

// Redux:
import { goToLive } from 'actions/schedule'

class TimeShift extends React.Component {
	constructor() {
		super()

		this.state = {
			offsetTime: ''
		}
	}

	componentDidMount() {
		this.updateTime()

		this.heartbeat = setInterval( () => {
			this.updateTime()
		}, 1000 * 60 )
	}

	componentWillUnmount() {
		clearInterval( this.heartbeat )
	}

	componentDidUpdate( prevProps, prevState ) {
		const { nowPlaying, seekSecondsForPercentCalcOnly } = this.props

		// Update the shifted time value:
		if ( seekSecondsForPercentCalcOnly != prevProps.seekSecondsForPercentCalcOnly ) {
			this.updateTime()
		}
	}

	updateTime = () => {
		const { secondsFromTrackStartToNow, seekSecondsForPercentCalcOnly, isLive, nowPlaying, nowPlayingLive } = this.props
		const offsetTotal = secondsFromTrackStartToNow - seekSecondsForPercentCalcOnly

		const timeNow = DateTime.local().toLocaleString( DateTime.TIME_SIMPLE )
		const offsetTime = DateTime.local().minus( { seconds: offsetTotal } ).toLocaleString( DateTime.TIME_SIMPLE )

		this.setState( {
			timeNow: timeNow,
			offsetTime: offsetTime
		} )
	}

	handleLiveClick = () => {
		this.props.goToLive()
	}

	render() {
		const { showRewindWarning, nowPlaying, isLive, secondsFromTrackStartToNow, seekSecondsForPercentCalcOnly } = this.props
		const { timeNow, offsetTime } = this.state

		return (
			<div className="time-shift">
				{ ( nowPlaying.is_favourites ) &&
					<div className="-not-live">
						Playing your favourites <span className="-go-live" onClick={ this.handleLiveClick }>(back to live radio)</span>
					</div>
				|| ( nowPlaying.is_podcasts ) &&
					<div className="-not-live">
						Playing a podcast <span className="-go-live" onClick={ this.handleLiveClick }>(back to live radio)</span>
					</div>
				|| ( nowPlaying.is_recent_episodes ) &&
					<div className="-not-live">
						Playing a recent episode <span className="-go-live" onClick={ this.handleLiveClick }>(back to live radio)</span>
					</div>
				|| ( ! isLive && timeNow != offsetTime && ! showRewindWarning ) &&
					<div className="-not-live">
						Time shifted to { offsetTime } <span className="-go-live" onClick={ this.handleLiveClick }>(back to live radio)</span>
					</div>
				}
			</div>
		)
	}
}


const mapStateToProps = ( state, ownProps ) => {
	return {
		isLive: state.schedule.isLive,
		showRewindWarning: state.schedule.showRewindWarning,
		secondsFromTrackStartToNow: state.schedule.secondsFromTrackStartToNow,
		seekSecondsForPercentCalcOnly: state.schedule.seekSecondsForPercentCalcOnly,
		nowPlaying: state.schedule.nowPlaying,
		nowPlayingLive: state.schedule.nowPlayingLive
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		goToLive() {
			dispatch( goToLive() )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( TimeShift )
